import React from 'react'
import { NavLink } from 'react-router-dom'
import todayshow from '../image/todayshow.jpg'

const Varirtydetails6 = () => {
  return (
    <div>
         <div>
        <div className="bg-gradient-to-r from-pink-200 to-fuchsia-100 overflow-hidden h-screen">
        <NavLink to="/varietydetails6"> <a class="group sm:flex rounded-xl dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600 p-5" href="https://www.youtube.com/watch?v=HhHPzux4vZ8">
      <div class="flex-shrink-0 relative rounded-xl overflow-hidden w-full h-[200px] sm:w-[250px] sm:h-[350px]">
        <img class="w-full h-full absolute top-0 start-0 object-cover" src={todayshow} alt="Image Description"/>
      </div>
      <div class="grow">
        <div class="p-4 flex flex-col h-full sm:p-6">
          <div class="mb-3">
            <p class="inline-flex items-center gap-1.5 py-1.5 px-3 rounded-md text-xs font-medium bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-200">
            Variety Show
            </p>
          </div>
          <h3 class="text-lg sm:text-2xl font-semibold text-purple-500 group-hover:text-blue-600 dark:text-gray-300 dark:group-hover:text-white">
          TODAY Show
          </h3>
          <div className='border-2 p-2 border-blue-300 hover:border-purple-400 rounded-lg mt-3'>
          <p class="mt-2 text-gray-600 dark:text-gray-400">
            <span className='font-bold text-md'>Genres: </span>Variety Show
          </p>
          <p class="mt-2 text-gray-600 dark:text-gray-400">
            <span className='font-bold text-md'>Release Date: </span> February 21, 2020
          </p>
          <p class="mt-2 text-gray-600 dark:text-gray-400">
            <span className='font-bold text-md '>Episode: </span>4
          </p>
          </div>
        </div>
      </div>
    </a></NavLink>
    <hr class="border-purple-500 mt-5"></hr>

<div>
  <div className='flex justify-center'>
     <h1 className='font-bold text-2xl p-2 text-blue-500'>About the show</h1>
  </div>
  <div className='p-5 text-lg font-semibold text-gray-500'>
      <p>On February 21, 2020, BTS made their debut on the 'TODAY show' where they sat down to talk about their album titled 'Map of the Soul: 7.'' </p>
  </div>
  <div className='p-5 text-lg font-semibold text-gray-500'>
      <p>The 'TODAY Show' is a daily live broadcast that provides current domestic and international news, weather reports and interviews with newsmakers from the worlds of politics, business, media, entertainment and sports. </p>
  </div>
  <div className='text-2xl font-bold text-blue-500 p-4'>
  APPEARANCES
  </div>
  <div className='text-purple-500 text-xl font-semibold p-1 ml-7'>
      <p>Feb 21, 2020: BTS appeared to promote the release of their 'Map of the Soul: 7' album. </p>
<p>Aug 24, 2020: BTS sat down for an interview about their song 'Dynamite.'</p>
<p>Sep 29, 2020: BTS performed their songs 'Anpanman' and 'Dynamite' as part of the 'Citi Concert Series.'</p>
<p>SNov 8, 2023:  Jung Kook to make a solo appearance on the 'Citi Concert Series' on November 8, 2023 @ 8am ET/5am PT to promote his solo album 'Golden'.</p>
  </div>
</div>
        </div>
    </div>
    </div>
  )
}

export default Varirtydetails6
